import NewsServices from '../xx-vue/services/news'
export default {
    namespaced: true,
    state: {
        page: 1,
        limit: 6,
        total: 0,
        newsClass: '',
        normalNews: []
    },
    mutations: {
        getNewsList: (state, payload) => {
            state.normalNews = payload
            console.log(state.normalNews);
        },
        changePage: (state, payload) => {
            state.page = payload
        },
        changeLimit: (state, payload) => {
            state.limit = payload
        },
        changeClass: (state, payload) => {
            state.newsClass = payload
        },
        changeTotal: (state, payload) => {
            state.total = payload
        }
    },
    actions: {
        getNewsList: async ({ commit, state }) => {
            let result = await NewsServices.getNewsAsync({ page: state.page, limit: state.limit, type: 0, class_id: state.newsClass });
            commit('changeTotal', result.data.total)
            result = result.data.list.map((v) => {
                const dateArr = v.cd.split(" ")[0].split("-");
                const timeArr = v.cd.split(" ")[1];
                const date =
                    dateArr[0] +
                    "年" +
                    dateArr[1] +
                    "月" +
                    dateArr[2] +
                    "日" +
                    " " +
                    timeArr;
                return { ...v, cd: date };
            });
            commit('getNewsList', result)
        }
    },
    getters: {
        pages: state => {
            return Math.ceil(state.total / state.limit);
        }
    }
}